import Widgets from 'js-widget-hooks';

Widgets.register('dropdown', function (el) {
    const parent = el.parentNode;
    console.log(parent);

    el.addEventListener('click', function(){
        parent.classList.toggle('open');
    });
});